import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { makeRequest } from 'Douleutaras/services/apiClient';

export const JOB_SEARCH_ENDPOINT = 'api/public/job_search';

export interface JobSearchResponse {
  allocation: string;
  category: string;
  client_email: string;
  client_name: string;
  client_phone: string;
  jid: number;
  bid_id: number;
  status: string;
  text: string;
}

const searchMap = new Map();

export const fetchJobSearch = createAsyncThunk<Array<JobSearchResponse>, { search: string }>(
  'jobs/search/get',
  async ({ search }, api) => {
    if (!searchMap.has(search)) {
      const response = await makeRequest(JOB_SEARCH_ENDPOINT, {
        method: 'GET',
        additionalGetParams: {
          search
        }
      })(api);

      searchMap.set(search, response.data.results);

      return response.data.results;
    } else {
      return searchMap.get(search);
    }
  }
);

export const jobsSearchSlice = createSlice({
  name: 'jobsSearchV2',
  initialState: {
    loading: false,
    entries: []
  } as { loading: boolean; entries: Array<JobSearchResponse> },
  reducers: {
    clearSearch: state => {
      state.entries = [];
    }
  },
  extraReducers: builder => {
    builder.addCase(fetchJobSearch.pending, state => {
      state.loading = true;
    });
    builder.addCase(fetchJobSearch.fulfilled, (state, action) => {
      state.loading = false;
      state.entries = action.payload;
    });
  }
});

export const { clearSearch } = jobsSearchSlice.actions;
